module.exports = __webpack_public_path__ + "img/login_right.a3c3dc70.png";